import { useIsSubUser } from "melco-shared-logic";

export const useIsAllowedToChangeAccountName = () => {
  const isSubUser = useIsSubUser();

  // only master users can update the account name
  return !isSubUser;
};
